var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, updateData, createData, } from "../dataAccess";
// Get all sites
export const getSites = (includeArchived) => __awaiter(void 0, void 0, void 0, function* () {
    let url = `Sites/sites`;
    if (includeArchived) {
        url = url + `?includeArchived=true`;
    }
    return getData(url);
});
// Create a new site
export const createSite = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Sites/sites-create`;
    return createData(url, item);
});
// Update an existing site
export const updateSite = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Sites/site-update`;
    return updateData(url, item);
});
// Delete a site
export const deleteSite = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Sites/Sites-delete`;
    return updateData(url, item);
});
